import {
    FETCH_PUSHES_DAILY_AVERAGE,
    FETCH_PUSHES_DAILY_AVERAGE_FAIL,
    FETCH_PUSHES_DAILY_AVERAGE_FETCHING,
    FETCH_PUSHES_DAILY_AVERAGE_SUCCESS
} from '../../actions/ActionTypes';

const INITIAL_STATE = {
    data: {},
    dailyAverageFetching: false,
    dailyAverageFetchFail: false
};

const fetchPushesDailyAverageFetching = (state, action) => {
    return {
        ...state,
        dailyAverageFetching: true,
        dailyAverageFetchFail: false
    };
};

const fetchPushesDailyAverageSuccess = (state, action) => {
    return {
        ...state,
        data: {
            ...state.data,
            [action.calendarDate]: action.data
        },
        dailyAverageFetching: false,
        dailyAverageFetchFail: false
    };
};

const fetchPushesDailyAverageFail = (state, action) => {
    return {
        ...state,
        data: {
            ...state.data,
            [action.calendarDate]: {}
        },
        dailyAverageFetching: false,
        dailyAverageFetchFail: true
    };
};

/** handlers */
const handlers = {
    [FETCH_PUSHES_DAILY_AVERAGE_FETCHING]: fetchPushesDailyAverageFetching,
    [FETCH_PUSHES_DAILY_AVERAGE_SUCCESS]: fetchPushesDailyAverageSuccess,
    [FETCH_PUSHES_DAILY_AVERAGE_FAIL]: fetchPushesDailyAverageFail
};

export default function dailyPushes(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];
    if (!handler) return state;
    return handler(state, action);
}

/** actions */

export function fetchPushesDailyAverage(calendarDate, evictCache) {
    return {
        type: FETCH_PUSHES_DAILY_AVERAGE,
        calendarDate,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

/** selector */
export function selectDailyPushes(state) {
    return state.dailyPushes;
}

export function getPushesDailyAverage(state, calendarDate) {
    const dailyPushes = selectDailyPushes(state);
    return dailyPushes.data[calendarDate] || null;
}

export function isPushesDailyAverageFetching(state) {
    const dailyPushes = selectDailyPushes(state);
    return dailyPushes.dailyAverageFetching;
}

export function isPushesDailyAverageFetchFail(state) {
    const dailyPushes = selectDailyPushes(state);
    return dailyPushes.dailyAverageFetchFail;
}
